<script>
import { authMethods } from '@state/helpers'

export default {
  page: {
    title: 'Puslapis kraunasi...',
  },

  created() {
    this.logOut().then(() => {
      this.$router.push({ name: 'login' })
    })
  },

  methods: {
    ...authMethods,
  },
}
</script>

<template>
  <div class="flex flex-1 items-center justify-center">
    <Transition appear>
      <font-awesome-icon
        :icon="['fas', 'spinner']"
        spin
        class="text-6xl text-gray-500"
      />
    </Transition>
  </div>
</template>
